import Axios from 'axios';

import { isBookingEvent } from '@libs/EventTypes';

const onFetchEvents = async (filters, currentUser) => {
    const { eventsParams, startDate, endDate } = filters;
    try {
        let newEvents = [];
        for (const eventParam of eventsParams) {
            const { path, params, type } = eventParam;
            let data = { ...params };
            data = {
                ...data,
                nwag: currentUser.ActiveContext.nwAgId,
                deps: [...currentUser.ActiveContext.activeDepartments],
                from: startDate, //period && period[0],
                to: endDate, //period && period[1],
            };
            const response = await Axios.post(path, data);
            const eventsByType = response
                .filter((event) => {
                    return true;
                })
                .map((event) => {
                    return {
                        ...event,
                        type,
                    };
                });
            newEvents = [...newEvents, ...eventsByType];
        }
        return newEvents;
    } catch (error) {
        console.error('Search Events Error => ', error);
    }
};

const getUrlAndParams = (eventType, filters) => {
    //eventSubtypeCode
    const { modelID, clientID, serviceID, hasTransactions, Booker, projectCategoryID, customFields } = filters;
    const hasCustomFields = customFields && Object.keys(customFields).length > 0;
    switch (eventType.toLowerCase()) {
        case 'casting':
            let castingParams = {
                modelID,
                globalClientID: clientID,
                eventType: 'Casting',
                UserCreated: Booker,
                projectCategoryID,
            };
            if (hasTransactions !== undefined) {
                castingParams = {
                    ...castingParams,
                    hasTransactions: hasTransactions,
                };
            }
            const casting_subtypes = filters[eventType].eventSubtypeCode;
            if (casting_subtypes && casting_subtypes.length > 0) {
                castingParams = {
                    ...castingParams,
                    eventSubtypeCode: [...casting_subtypes],
                };
            }
            if (hasCustomFields) {
                castingParams = {
                    ...castingParams,
                    customFields,
                };
            }
            return { path: '/events/Search', params: castingParams, type: 'casting' };
        case 'job':
            let jobParams = {
                modelID,
                globalClientID: clientID,
                eventType: 'Job',
                UserCreated: Booker,
                projectCategoryID,
            };
            if (hasTransactions !== undefined) {
                jobParams = {
                    ...jobParams,
                    hasTransactions: hasTransactions,
                };
            }
            const job_subtypes = filters[eventType].eventSubtypeCode;
            if (job_subtypes && job_subtypes.length > 0) {
                jobParams = {
                    ...jobParams,
                    eventSubtypeCode: [...job_subtypes],
                };
            }
            if (filters[eventType].optionNumber !== undefined && filters[eventType].optionNumber !== null) {
                jobParams = {
                    ...jobParams,
                    optionNumber: filters[eventType].optionNumber,
                };
            }
            if (hasCustomFields) {
                jobParams = {
                    ...jobParams,
                    customFields,
                };
            }
            return { path: '/events/Search', params: jobParams, type: 'job' };
        case 'ext':
            let extParams = {
                modelID,
                globalClientID: clientID,
                eventType: 'Ext',
                UserCreated: Booker,
                projectCategoryID,
            };
            if (hasTransactions !== undefined) {
                extParams = {
                    ...extParams,
                    hasTransactions: hasTransactions,
                };
            }
            const ext_subtypes = filters[eventType].eventSubtypeCode;
            if (ext_subtypes && ext_subtypes.length > 0) {
                extParams = {
                    ...extParams,
                    eventSubtypeCode: [...ext_subtypes],
                };
            }
            if (filters[eventType].optionNumber !== undefined && filters[eventType].optionNumber !== null) {
                extParams = {
                    ...extParams,
                    optionNumber: filters[eventType].optionNumber,
                };
            }
            if (hasCustomFields) {
                extParams = {
                    ...extParams,
                    customFields,
                };
            }
            return { path: '/events/Search', params: extParams, type: 'ext' };
        case 'travel':
            let travelParams = {
                modelID,
                projectClientID: clientID,
                serviceID,
                UserCreated: Booker,
                projectCategoryID,
            };
            if (hasTransactions !== undefined) {
                travelParams = {
                    ...travelParams,
                    hasTransactions: hasTransactions,
                };
            }
            const travel_types = filters[eventType].travelTypes;
            if (travel_types && travel_types.length > 0) {
                travelParams = {
                    ...travelParams,
                    transport: [...travel_types],
                };
            }
            if (hasCustomFields) {
                travelParams = {
                    ...travelParams,
                    customFields,
                };
            }
            return { path: '/travels/Search', params: travelParams, type: 'travel' };
        case 'followup':
            let followupParams = {
                modelID,
                projectClientID: clientID,
                serviceID,
                UserCreated: Booker,
                projectCategoryID,
            };
            //let followupParams = { modelID: modelId, projectClientID: clientId, serviceID: serviceId, UserCreated: userID, projectCategoryID: eventFilters[eventType].projectCategoryID };
            if (hasTransactions !== undefined) {
                followupParams = {
                    ...followupParams,
                    hasTransactions: hasTransactions,
                };
            }
            const labels = filters[eventType].labels;
            if (labels && labels.length > 0) {
                followupParams = {
                    ...followupParams,
                    FollowUpLabelCode: [...labels],
                };
            }
            if (hasCustomFields) {
                followupParams = {
                    ...followupParams,
                    customFields,
                };
            }
            return { path: '/FollowUps/Search', params: followupParams, type: 'followup' };
        case 'accommodation':
            let accommodationParams = {
                modelID,
                projectClientID: clientID,
                serviceID,
                SubType: 0,
                UserCreated: Booker,
                projectCategoryID,
            };
            //let accommodationParams = { modelID: modelId, projectClientID: clientId, serviceID: serviceId, SubType: 0, UserCreated: userID, projectCategoryID: filters[eventType].projectCategoryID };
            if (hasTransactions !== undefined) {
                accommodationParams = {
                    ...accommodationParams,
                    hasTransactions: hasTransactions,
                };
            }
            if (hasCustomFields) {
                accommodationParams = {
                    ...accommodationParams,
                    customFields,
                };
            }
            return { path: '/accommodation/Search', params: accommodationParams, type: 'accommodation' };
        case 'roomlodging':
            let roomLodgingParams = {
                modelID,
                projectClientID: clientID,
                serviceID,
                SubType: 1,
                UserCreated: Booker,
            };
            //let roomLodgingParams = { ModelID: modelId, projectClientID: clientId, serviceID: serviceId, SubType: 1, UserCreated: userID, projectCategoryID: filters[eventType].projectCategoryID };
            if (hasTransactions !== undefined) {
                roomLodgingParams = {
                    ...roomLodgingParams,
                    hasTransactions: hasTransactions,
                };
            }
            return { path: '/accommodation/Search', params: roomLodgingParams, type: 'accommodation' };
        case 'extjob':
            let externaljobParams = {
                modelID,
                agencyID: clientID,
                UserCreated: Booker,
            };
            //let externaljobParams = { modelID: modelId, agencyID: clientId, UserCreated: userID };
            if (hasTransactions !== undefined) {
                externaljobParams = {
                    ...externaljobParams,
                    hasTransactions: hasTransactions,
                };
            }
            return { path: '/ExternalJobs/Search', params: externaljobParams, type: 'extjob' };
        case 'meeting':
            let meetingParams = {
                contactID: clientID,
                UserCreated: Booker,
                projectCategoryID,
            };
            //const meetingParams = { contactID: clientId, UserCreated: userID, projectCategoryID: filters[eventType].projectCategoryID };
            if (hasCustomFields) {
                meetingParams = {
                    ...meetingParams,
                    customFields,
                };
            }
            return { path: '/meetings/Search', params: meetingParams, type: 'meeting' };
        default:
            return null;
    }
};

export const groupEventsByProjects = async (events) => {
    const eventsWithProjectId = events.filter((event) => event.Project && event.Project.ID);
    const uniqueProjectIds = [...new Set(eventsWithProjectId.map((event) => event.Project.ID))];
    const projects = await Axios.post('/projects/getforeventsearch', uniqueProjectIds);
    return { Events: [...events], Projects: [...projects] };
};

export const buildEventFiltersFromSimpleParams = (modelId, clientId, eventTypes) => {
    const filters = { modelID: modelId, clientID: clientId };
    eventTypes.forEach((type) => {
        filters[type] = { eventSubtypeCode: null };
    });
    return filters;
};

export const getEventsForSearch = async (filters, currentUser, groupByProject) => {
    const { modelID, clientID, serviceID, hasTransactions, WorkingOn, projectCategoryID } = filters;
    let startDate = null;
    let endDate = null;
    if (WorkingOn) {
        startDate = WorkingOn[0];
        endDate = WorkingOn[1];
    }
    const eventTypeFilters = [
        'casting',
        'job',
        'ext',
        'travel',
        'followup',
        'roomLodging',
        'extjob',
        'meeting',
        'accommodation',
    ];
    const eventsParams = [];
    const hasCustomFields = filters.customFields && Object.keys(filters.customFields).length > 0;
    for (const filterKey of eventTypeFilters) {
        if (filters[filterKey]) {
            if (
                !(
                    (modelID && filterKey === 'meeting') ||
                    (clientID && filterKey === 'roomLodging') ||
                    (serviceID && (isBookingEvent(filterKey) || filterKey === 'extjob')) ||
                    (hasTransactions && filterKey === 'meeting') ||
                    (projectCategoryID && (filterKey === 'extjob' || filterKey === 'roomLodging')) ||
                    (hasCustomFields && (filterKey === 'extjob' || filterKey === 'roomLodging'))
                )
            ) {
                eventsParams.push(getUrlAndParams(filterKey, filters)); //, eventSubtypeCode));
            }
        }
    }
    const events = await onFetchEvents({ eventsParams, startDate, endDate }, currentUser);
    if (groupByProject) {
        const groupedEvents = await groupEventsByProjects(events);
        return groupedEvents;
    } else {
        return events;
    }
};
